import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Title } from 'react-admin';
import { Grid } from '@mui/material';
import AppOpenedCount from './AppOpenedCount';
import UserProfileCount from './UserProfileCount';
import AppVersionCount from './dashboards/AppVersionCount';
import { usePermissionsExt } from '../DataProviderExtension/authExtension';
import TradeUnionProfileCount from './dashboards/TradeUnionProfileCount';

const Dashboard = () => {
	const {
		isLoading, master, tradeUnionAdmin, tradeUnionAdminIds,
	} = usePermissionsExt();
	if (isLoading) {
		return null;
	}
	return (
		<Card>
			<Title title="Главная аналитическая панель" />
			<CardContent>
				<Grid container spacing={2}>
					{master && (
						<Grid item xs={12} md={6} lg={4} sx={{ minHeight: '15vw' }}>
							<AppOpenedCount style={{ height: '100%' }} />
						</Grid>
					)}
					{(master) && (
						<Grid item xs={12} md={6} lg={4} sx={{ minHeight: '15vw' }}>
							<UserProfileCount style={{ height: '100%' }} />
						</Grid>
					)}
					{(tradeUnionAdmin)
						&& tradeUnionAdminIds.map((tuId) => (
							<Grid key={tuId} item xs={12} md={6} lg={4} sx={{ minHeight: '15vw' }}>
								<TradeUnionProfileCount style={{ height: '100%' }} tradeUnionId={tuId} />
							</Grid>
						))}
					<Grid item xs={12} md={6} lg={4} sx={{ minHeight: '15vw' }}>
						<AppVersionCount style={{ height: '100%' }} />
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
};

export default Dashboard;
